import React, { useMemo, useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import SVGInline from 'react-svg-inline';

import { useSidebarMenu } from 'components/Sidebar/data';
import AgentFeedback from 'features/AgentFeedback/desktop';
import Logo from 'components/Logo';

import ListItem from './ListItem';
import feedbackWhiteSVG from '../../data/img/white/feedback.svg';

import './Sidebar.scss';

const b = block('sidebar');

const Sidebar = ({ changeMenuOpen = () => null }) => {
  const locale = useSelector(state => state.locale.locale);
  const { isVisible: feedbackLinkVisible } = useSelector(state => state.agentFeedback);

  const [openModal, setOpenModal] = useState(false);

  const sidebarMenu = useSidebarMenu();
  const Items = useMemo(
    () =>
      sidebarMenu.map(el => (
        <ListItem item={el} key={el.title} changeMenuOpen={changeMenuOpen} onSpecialAction={() => setOpenModal(true)} />
      )),
    [sidebarMenu, changeMenuOpen],
  );

  const onCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <div className={b()}>
      <div className={b('logo-wrapper')}>
        <div className={b('logo')}>
          <Logo />
        </div>
      </div>
      <div className={b('menu')}>{Items}</div>
      {feedbackLinkVisible && (
        <div className={b('contact-button')} onClick={() => setOpenModal(true)}>
          <div className={b('contact-button-content')}>
            <SVGInline svg={feedbackWhiteSVG} className={b('contact-button-icon').toString()} />
            <span className={b('contact-button-title')}>{locale.contactLinkText}</span>
          </div>
        </div>
      )}
      {openModal && <AgentFeedback closeFunction={onCloseModal} />}
    </div>
  );
};

export default Sidebar;
